/* global global, document */
/* eslint prefer-template: 0 */
import throttle from 'lodash/throttle';
import search from './../utils/search';

const NO_RESULTS_STRING = '<li class="no-results-found">Sorry, we can\'t seem to find any results for $1'
+ 'us directly at <a href="mailto:support@easypost.com">support@easypost.com</a>, '
+ 'and we\'ll give you an answer as soon as possible.</li>';
const NO_RESULTS_CATEGORY_STRING = '$1 in the $2 category. '
+ 'Try widening your results by entering your search again from the <a href="/knowledgebase">Knowledge Base Home</a> page or ask ';
const NO_CATEGORY_STRING = '$1. Try asking ';

const kb = {
  initialize() {
    this.getStore().done((data) => {
      kb.data = JSON.parse(data.replace(/\\/g, '&#92;'));
      this.runSearch();
      this.setEventListeners();
    });
  },

  getStore() {
    return $.ajax({
      url: '/json/knowledgebase_data.html',
    });
  },

  runSearch(searchString, {searchbox = false} = {}) {
    const query = searchbox === true ? searchString : this.getQueryVariable('query', window.location.search);
    const category = $('#search-box').data('category');
    let data = kb.data;
    if (query) {
      // filter out category if necessary
      if (category.length) {
        data = Object.keys(data)
                .filter(key => kb.data[key].category === category.toLowerCase())
                .reduce((res, key) => {
                  const obj = res;
                  obj[key] = kb.data[key];
                  return obj;
                }, {});
      }
      // run the search on page load and display results
      this.displaySearchResults(search(data, query), query, category);
    } else {
      this.clearSearch();
    }

    // make sure that searchbox input value matches the query string on load
    this.updateSearchString(query || '');
  },
  clearSearch(){
    const searchResults = document.getElementById('kb-search-results');
    //clear out query variable
    this.updateQueryVariable();
    // clear out the searhbox
    this.updateSearchString();
    // show the default
    this.toggleDefault(true);
    // clear out the results
    searchResults.innerHTML = '';
  },

  displaySearchResults(results, searchString, category) {
    const searchResults = document.getElementById('kb-search-results');
    let appendString = '<h4 class="search-results-header">Search Results:</h4>';
    let item;

    // if search string is empty, just show the default
    if (!searchString || searchString.length === 0) {
      this.clearSearch();
    } else if (searchString.length < 3) {
      // do nothing
      // give a minimum of 3 characters for a search
      return;
    } else {
      if (results && results.result && results.result.length) { // Are there any results?
        for (let i = 0; i < results.result.length; i += 1) {  // Iterate over the results
          item = kb.data[results.result[i].ref];
          appendString += '<li class="search-result-item"><a class="kb-search-row ' + (item.sub_category || item.category) + '" href="' + item.url + '">';
          appendString += '<span class="search-result-title">' + item.title + '</span><br/>';
          appendString += '<span class="search-result-string">' + this.highlightTerms(item.content.substring(0, 150), results.stem) + '</span></a></li>';
        }
        searchResults.innerHTML = appendString;
      } else {
        // no results found
        searchResults.innerHTML = category
          ? NO_RESULTS_STRING.replace('$1', NO_RESULTS_CATEGORY_STRING.replace('$1', searchString).replace('$2', category))
          : NO_RESULTS_STRING.replace('$1', NO_CATEGORY_STRING.replace('$1', searchString));
      }
      // hide the default
      this.toggleDefault(false);
    }
  },

  highlightTerms(dataString, searchArray) {
    let returnString = dataString;
    searchArray.forEach((word) => {
      // don't highlight any stems that are less than three letters
      if (word.length > 2) {
        const re = new RegExp(`((<strong>)?(${word}?\\w+)(</strong>)?)`, 'gi');
        returnString = returnString.replace(re, '<strong>$3</strong>');
      }
    });

    return returnString;
  },

  updateSearchString(searchTerm) {
    $('#search-box').val(searchTerm);
  },

  getQueryVariable(variable, windowLocationSearch) {
    const query = windowLocationSearch.substring(1);
    const vars = query.split('&');

    for (let i = 0; i < vars.length; i += 1) {
      const pair = vars[i].split('=');

      if (pair[0] === variable) {
        return decodeURIComponent(pair[1].replace(/\+/g, '%20'));
      }
    }
    return false;
  },

  updateQueryVariable(searchString) {
    const location = window.location.pathname;
    if (searchString) {
      window.history.pushState(null, null, `${location}?query=${searchString}`);
    } else if (window.location.search) {
      // clear out the query
      window.history.pushState(null, null, location);
    }
  },

  toggleDefault(show) {
    if ($('.kb-links')) {
      if (show) {
        $('.kb-links').addClass('loaded');
      } else {
        $('.kb-links').removeClass('loaded');
      }
    }
  },
  setEventListeners() {
    // watch for changes in the search input
    $('#search-box').on('keyup', throttle(function runSearch() {
      kb.runSearch($(this).val(), {searchbox: true});
    }, 300));
    // expand the carriers icons
    $('#knowledgebase-carriers h4').on('click', function toggleCarriers() {
      $('.carrier-faq').slideToggle();
      $(this).toggleClass('expanded');
    });
    $(window).on('popstate', kb.runSearch.bind(kb));
    $('.clear-search').click(()=> {
      kb.clearSearch();
    })
    $('#search-form').submit(e=> {
      e.preventDefault();
    })
  },
};


export function knowledgebase() {
  // on load
  kb.initialize();
}

// expose the entire object for testing only
export { kb as knowledgebaseTest };



// WEBPACK FOOTER //
// ./static-pages/knowledgebase.js